import React from 'react';
import { LogoListStatic } from '../../layouts/LogoListStatic';
import {
  fontBody,
  fontBodyMiniMedium,
  fontCaption,
  fontHeading2,
  fontHeading3,
  fontHeading5,
} from '../../styles/typographyNew';
import { PayFitColor } from '../../types/module';
import { applyBackgroundColor, classNames } from '../../utils/style';
import { ButtonTracking } from '../../utils/tracking/ButtonTracking';
import { addDivCorner } from '../../utils/utils';
import { ValuePropositionCardProps } from './type';

export const ValuePropositionCard = ({
  title,
  listItems,
  aside,
  logoList,
  cards,
  className,
}: ValuePropositionCardProps) => (
  <div
    className={classNames(
      'ValuePropositionCard flex flex-col gap-[50px] p-[30px] pt-[60px] md:p-[87px]',
      className,
    )}
  >
    <div className="flex flex-col-reverse md:flex-row gap-48 md:gap-40 justify-between">
      <div className="flex flex-col gap-24 md:gap-40">
        {title && (
          <h2
            className={classNames(
              fontHeading3,
              'text-center md:text-left text-neutral-301 max-w-[524px]',
            )}
          >
            {title}
          </h2>
        )}
        {listItems && listItems.length > 0 && (
          <ul className="flex flex-col gap-16 max-w-[640px]">
            {listItems.map((item, i) => (
              <li
                key={i}
                className={classNames(fontBody, 'text-navy-80 flex gap-12')}
              >
                <img src="https://payfit.com/icon/check.svg" alt="checkmark" />
                {item}
              </li>
            ))}
          </ul>
        )}
        {logoList && (
          <LogoListStatic
            logos={logoList.logos}
            title={logoList.title}
            classname={{
              parent:
                'flex flex-col-reverse gap-16 md:gap-24 text-justify overflow-hidden md:overflow-visible',
              logoContainer:
                'flex-wrap sm:flex-nowrap !justify-start !m-0 gap-[26px] md:gap-[32px] w-fit-content',
              title: classNames(
                fontCaption,
                '!mt-0 md:mt-[32px] !text-[#65778C]',
              ),
            }}
          />
        )}
      </div>
      <div
        className={classNames(
          'relative',
          'flex flex-col text-center justify-center align-middle',
          'm-auto mt-0 md:m-0 md:mt-40 lg:mt-[81px] min-h-[214px] md:max-h-[250px] w-[262px] px-16 gap-8',
          addDivCorner('top-left'),
          addDivCorner('top-right'),
        )}
      >
        {aside?.notation && (
          <p className={classNames(fontHeading2, 'text-navy-200')}>
            {aside.notation}
          </p>
        )}
        {aside?.title && (
          <p className={classNames(fontBodyMiniMedium, 'text-navy-200 px-4')}>
            {aside.title}
          </p>
        )}
        {aside?.subtitle && (
          <p className={classNames(fontCaption, 'text-navy-80')}>
            {aside.subtitle}
          </p>
        )}
        <span
          className={classNames(
            addDivCorner('bottom-left'),
            addDivCorner('bottom-right'),
          )}
        ></span>
      </div>
    </div>
    {cards && (
      <div className="flex flex-col md:flex-row justify-start gap-32 md:gap-[49px]">
        {cards.map(
          (
            {
              as: Component = 'div',
              title,
              subtitle,
              image,
              backgroundColor,
              ...cardProps
            }: any,
            i,
          ) => {
            if (Component !== ButtonTracking) {
              delete cardProps.labelTracking;
            }

            return (
              <Component
                {...cardProps}
                className="flex flex-col w-full gap-16 md:w-[310px] md:gap-32 overflow-hidden"
                key={i}
              >
                {image && (
                  <div
                    className={classNames(
                      backgroundColor
                        ? `${applyBackgroundColor(
                            backgroundColor as PayFitColor,
                          )}`
                        : '',
                      'aspect-4/3 w-full rounded-[16px]',
                      'flex justify-center items-center overflow-hidden',
                    )}
                  >
                    {image}
                  </div>
                )}
                <div className="flex flex-col gap-8 md:gap-16">
                  <h3 className={classNames(fontHeading5, 'text-navy-200')}>
                    {title}
                  </h3>
                  <p className={classNames(fontBody, 'text-navy-80')}>
                    {subtitle}
                  </p>
                  {/* Placer CTA ICI */}
                </div>
              </Component>
            );
          },
        )}
      </div>
    )}
  </div>
);
